export default __webpack_public_path__ + "static/verified-fe9ba47605107b9a0b8e6ea9a0fb9887.png";